import script from "./HeaderWarningPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderWarningPanel.vue?vue&type=script&setup=true&lang=js"

import "./HeaderWarningPanel.vue?vue&type=style&index=0&id=115f3379&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-115f3379"]])

export default __exports__